module.exports = __webpack_public_path__ + "img/allottee2_7-8-2021.231d2f14.jpg";